import { useSendReportEmail, useShippingForm } from '@/services/reports';

export type GenerateShippingFormParams = {
  sendEmail: boolean;
  shipmentIds?: string[];
  shipmentNumbers?: string[];
  showPedigree?: boolean;
};

export const useGenerateShippingForm = (defaultShipmentId?: string) => {
  const [shippingForm] = useShippingForm();
  const sendReportEmail = useSendReportEmail();

  const generateShippingForm = async ({
    sendEmail,
    shipmentIds,
    shipmentNumbers,
    showPedigree,
  }: GenerateShippingFormParams) => {
    const ids = shipmentIds ?? (defaultShipmentId ? [defaultShipmentId] : []);
    if (!ids.length) return;

    const res = await shippingForm(
      { shipmentIds: ids, showPedigree },
      sendEmail ? { isForEmail: true } : undefined,
    );

    if (sendEmail) {
      const message = shipmentNumbers?.length
        ? shipmentNumbers.length === 1
          ? `Shipment: ${shipmentNumbers.join(', ')}`
          : `Shipments: ${shipmentNumbers.join(', ')}`
        : '';
      await sendReportEmail({
        subject: 'Please bring to Shipping',
        message,
        reportUrl: res.url,
        recipients: [
          'Cody.Hill@transova.com',
          'Leah.VanSurksum@transova.com',
          'Bailey.Farrer@transova.com',
          'abby.dunn@transova.com',
        ],
      });
    }
  };

  return generateShippingForm;
};
